import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER, SYSTEM_COMMON_CODE_PATH } from '../../../constant/Constant';
import { request } from '../../ApiModule';

const INIT = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'INIT';

const HANDLE_CODE_GROUPS = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'HANDLE_CODE_GROUPS';
const HANDLE_CODES = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'HANDLE_CODES';

const ACTION_CODE_GROUPS_SEARCH = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_GROUPS_SEARCH';
const ACTION_CODE_GROUPS_ADD = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_GROUPS_ADD';
const ACTION_CODE_GROUPS_EDIT = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_GROUPS_EDIT';
const ACTION_CODE_GROUPS_REMOVE = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_GROUPS_REMOVE';
const ACTION_CODE_SEARCH = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_SEARCH';
const ACTION_CODE_ADD = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_ADD';
const ACTION_CODE_EDIT = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_EDIT';
const ACTION_CODE_REMOVE = SYSTEM_COMMON_CODE_PATH + PATH_DELIMITER + 'ACTION_CODE_REMOVE';

export const actionInit = createAction(INIT);
export const actionCodeGroupSearch = createAction(ACTION_CODE_GROUPS_SEARCH);
export const actionCodeGroupAdd = createAction(ACTION_CODE_GROUPS_ADD);
export const actionCodeGroupEdit = createAction(ACTION_CODE_GROUPS_EDIT);
export const actionCodeGroupRemove = createAction(ACTION_CODE_GROUPS_REMOVE);
export const actionCodeSearch = createAction(ACTION_CODE_SEARCH);
export const actionCodeAdd = createAction(ACTION_CODE_ADD);
export const actionCodeEdit = createAction(ACTION_CODE_EDIT);
export const actionCodeRemove = createAction(ACTION_CODE_REMOVE);

export function* systemCommonCodeSagas() {
    yield takeEvery(ACTION_CODE_GROUPS_SEARCH, actionCodeGroupSearchSaga);
    yield takeEvery(ACTION_CODE_GROUPS_ADD, actionCodeGroupAddSaga);
    yield takeEvery(ACTION_CODE_GROUPS_EDIT, actionCodeGroupEditSaga);
    yield takeEvery(ACTION_CODE_GROUPS_REMOVE, actionCodeGroupRemoveSaga);
    yield takeEvery(ACTION_CODE_SEARCH, actionCodeSearchSaga);
    yield takeEvery(ACTION_CODE_ADD, actionCodeAddSaga);
    yield takeEvery(ACTION_CODE_EDIT, actionCodeEditSaga);
    yield takeEvery(ACTION_CODE_REMOVE, actionCodeRemoveSaga);
}

function* actionCodeGroupSearchSaga() {
    const result = yield call(request, {
        method: 'get',
        url: '/api/code/code-groups',
    });
    yield put({
        type: HANDLE_CODE_GROUPS,
        payload: result,
    });
}

function* actionCodeGroupAddSaga({ payload: data }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/code/code-groups',
        data,
    });
    yield call(actionCodeGroupSearchSaga);
}

function* actionCodeGroupEditSaga({ payload: { cdGrpId, cdGrpNm } }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/code/code-groups/${cdGrpId}`,
        data: { cdGrpId, cdGrpNm },
    });
    yield call(actionCodeGroupSearchSaga);
}

function* actionCodeGroupRemoveSaga({ payload: { cdGrpId } }) {
    const result = yield call(request, {
        method: 'delete',
        url: `/api/code/code-groups/${cdGrpId}`,
    });
    yield call(actionCodeGroupSearchSaga);
}

function* actionCodeSearchSaga({ payload: { cdGrpId } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/code/code-groups/${cdGrpId}/codes`,
    });
    yield put({
        type: HANDLE_CODES,
        payload: result,
    });
}

function* actionCodeAddSaga({ payload: data }) {
    const result = yield call(request, {
        method: 'post',
        url: `/api/code/code-groups/${data.cdGrpId}/codes`,
        data,
    });
    yield call(actionCodeSearchSaga, { payload: data });
}

function* actionCodeEditSaga({ payload: data }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/code/code-groups/${data.cdGrpId}/codes/${data.cd}`,
        data,
    });
    yield call(actionCodeSearchSaga, { payload: data });
}

function* actionCodeRemoveSaga({ payload: data }) {
    const result = yield call(request, {
        method: 'delete',
        url: `/api/code/code-groups/${data.cdGrpId}/codes/${data.cd}`,
    });
    yield call(actionCodeSearchSaga, { payload: data });
}

const initialState = {
    codeGroups: [],
    codes: [],
};

const module = handleActions(
    {
        [INIT]: () => initialState,
        [HANDLE_CODE_GROUPS]: (state, { payload: codeGroups }) => ({ ...state, codeGroups }),
        [HANDLE_CODES]: (state, { payload: codes }) => ({ ...state, codes }),
    },
    initialState,
);

export default module;
